import { fvDateUtc } from '@fv/dates'

export function friendlyDate(
  date?: string | Date,
  format = 'MM/DD/YYYY hh:mm A',
  fallback = 'N/A',
) {
  if (!date) return fallback

  return fvDateUtc(date).format(format)
}
